export const SOURCE_LABELS = {
  "walk-in": "Khách vãng lai",
  "walk_in": "Khách vãng lai",
  "Walk-in": "Khách vãng lai",
  "Walk_in": "Khách vãng lai",
  "zalo": "Zalo",
  "Zalo": "Zalo",
  "facebook": "Facebook",
  "Facebook": "Facebook",
  "referral": "Giới thiệu",
  "Referral": "Giới thiệu",
  "Giới thiệu": "Giới thiệu",
  "Gioi thieu": "Giới thiệu",
  "old_customer": "Khách cũ",
  "Old Customer": "Khách cũ",
  "staff_input": "Nhân viên nhập",
  "Staff Input": "Nhân viên nhập",
  "social_group": "Nhóm Social",
  "Social Group": "Nhóm Social",
  "membership": "Hội viên",
  "Membership": "Hội viên",
  "unknown": "Không rõ",
  "Unknown": "Không rõ",
  "Khách vãng lai": "Khách vãng lai",
  "Khach vang lai": "Khách vãng lai",
  "Google": "Google",
  "google": "Google",
  "Khác": "Khác",
  "tournament": "Giải đấu",
  "Giải đấu": "Giải đấu",
  "Giai dau": "Giải đấu",
  "Tournament": "Giải đấu",
};

export const getSourceLabel = (source) => {
  if (!source) return "Không rõ";
  return SOURCE_LABELS[source] || source;
};

export const TAG_LABELS = {
  "Khach quen": "Khách quen",
  "Thue thang": "Thuê tháng",
  "Nhom": "Nhóm",
  "Moi": "Mới",
};

export const getTagLabel = (tag) => TAG_LABELS[tag] || tag;
